export default __webpack_public_path__ + "static/media/delivered_false.cc85f6c7.svg";